__turbopack_context__.v({
  "mainContent": "gKXzuG_mainContent",
  "showDesktop": "gKXzuG_showDesktop",
  "showMobile": "gKXzuG_showMobile",
});
